import { DoqFace, DoqType, getDashboardDoqSize } from '@ardoq/doq';
import { DoqyWithMessage } from './DoqyWithMessage';
import { TextOverflow } from '@ardoq/popovers';

const DOQ_TYPE = DoqType.DASHBOARD_BELLY_SIMPLE;

const WidgetWithMissingConfig = ({
  configurationInstructions,
}: {
  configurationInstructions: string[];
}) => (
  <DoqyWithMessage>
    <DoqFace doqType={DOQ_TYPE} doqSize={getDashboardDoqSize()} />
    <TextOverflow lineClamp={2}>
      {configurationInstructions?.join(' ')}
    </TextOverflow>
  </DoqyWithMessage>
);

export { WidgetWithMissingConfig };
